export interface AccountByType {
    name: string;
    sort: number;
    type: AccountType;
    isActive: boolean;
    marketplaceID: string;
    seller?: string;
    defaultWarehouseId?: string;
    reftoken:number;
    rtoken:number;
}

export enum AccountType {
    Amazon = "amazon",
    Walmart = "walmart",
    Ebay = "ebay",
    NewEgg = "newegg",
    Wish = "wish"
}

export interface Companies{
    companyId: number,
    companyName: string,
    fullName:string,
    email:string,
    phone:string,
    logoPath:string
}

export interface CreateConnection{
    email: string,
    password: string,
    companyId: number
}